import * as React from "react";
import styled, { css } from "styled-components";
import usePluginEntities from "hooks/usePluginEntities";
import MessageFieldRow from "views/components/messagelist/MessageFieldRow";
const TableRow = styled.tr(
  ({ theme }) => css`
    && {
      cursor: pointer;

      td {
        border-top: 0;
        padding-top: 0;
        padding-bottom: 4px;
        font-family: ${theme.fonts.family.monospace};
        color: ${theme.colors.variant.dark.info};
      }
    }
  `
);
const renderMessageFieldRow = (message, messageFieldType) => /* @__PURE__ */ React.createElement(MessageFieldRow, { message, messageFieldType });
const MessagePreview = ({
  onRowClick,
  colSpanFixup,
  message,
  messageFieldType,
  showMessageRow = false,
  config
}) => {
  var _a;
  const MessageRowOverride = (_a = usePluginEntities("views.components.widgets.messageTable.messageRowOverride")) == null ? void 0 : _a[0];
  return showMessageRow && /* @__PURE__ */ React.createElement(TableRow, { onClick: onRowClick }, /* @__PURE__ */ React.createElement("td", { colSpan: colSpanFixup }, !!MessageRowOverride && /* @__PURE__ */ React.createElement(
    MessageRowOverride,
    {
      messageFields: message.fields,
      config,
      renderMessageRow: () => renderMessageFieldRow(message, messageFieldType)
    }
  ), !MessageRowOverride && renderMessageFieldRow(message, messageFieldType)));
};
export default MessagePreview;
